import React from 'react';

const SearchCrossIcon = function() {
  return (
    <svg
      className={'search_cross'}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44384 15C1.18612 14.7348 1.04134 14.3751 1.04134 14C1.04134 13.6249 1.18612 13.2652 1.44384 13L13.1047 1C13.3624 0.734783 13.7119 0.585786 14.0764 0.585786C14.4409 0.585787 14.7904 0.734784 15.0481 1C15.3058 1.26522 15.4506 1.62493 15.4506 2C15.4506 2.37507 15.3058 2.73478 15.0481 3L3.38731 15C3.12959 15.2652 2.78005 15.4142 2.41558 15.4142C2.0511 15.4142 1.70156 15.2652 1.44384 15Z"
        fill="#B0BABF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.576 15C14.8337 14.7348 14.9785 14.3751 14.9785 14C14.9785 13.6249 14.8337 13.2652 14.576 13L2.91518 1C2.65746 0.734783 2.30792 0.585786 1.94345 0.585786C1.57898 0.585787 1.22944 0.734784 0.971715 1C0.713996 1.26522 0.56921 1.62493 0.569209 2C0.569209 2.37507 0.713995 2.73478 0.971715 3L12.6325 15C12.8902 15.2652 13.2398 15.4142 13.6043 15.4142C13.9687 15.4142 14.3183 15.2652 14.576 15Z"
        fill="#B0BABF"
      />
    </svg>
  );
};

export default SearchCrossIcon;
